
import { NgIf, NgClass, NgFor } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NextPage } from '@cvx/nextpage';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { AdminService } from '../../../../services/admin.service';
import { DropdownModule } from 'primeng/dropdown';
import { CommonService } from '../../../../services/common.service';
import { UserService } from '../../../../services/user.service';
import { CheckboxModule } from 'primeng/checkbox';
import { NotificationService } from '../../../../services/notification.service';
@Component({
    selector: 'app-omc-maintainance',
    imports: [NextPage, TableModule, NgIf, NgFor, CheckboxModule, DropdownModule, NgClass, ButtonModule, FormsModule, TabViewModule],
    templateUrl: './omc-maintainance.component.html',
    styleUrl: './omc-maintainance.component.scss'
})
export class OmcMaintainanceComponent {
  omcResult: any = {}
  omcWholeData: any[] = [];
  filterUserIdomcData: any[] = [];
  filterPlantomcData: any[] = [];
  omcOptionsUser: any = [];
  omcOptionsPlant: any = [];
  selectedOMCUser: any = '';
  selectedOMCName: any = '';
  selectedOMCEmail: any = '';
  selectedOMCPlant: any = '';
  isLoading: boolean = false;
  ShowAdded: boolean = false;
  isValid: boolean = false;
  requiredFlag: boolean = false;
  selectValidMaximo: boolean = false;
  validUserEntered: boolean = false;
  maximoList: any = [];
  selectMaximos: any[] = [];
  facilityName = '';
  userIdEntered = '';
  useremail = '';
  userName = '';
  constructor(private adminService: AdminService, private commonService: CommonService, private userService: UserService, private messageService: NotificationService) {
  }
  ngOnInit() {
    this.isLoading = true;
    this.ShowAdded = false;
    this.facilityName = this.commonService.getCurrentFacilityId();
    this.getOmcData();
  }
  getOmcData() {
    this.adminService.getOmcData("OMC").subscribe((response: any) => {
      this.omcResult = response;
      this.processData()
    });
  }
  processData() {
    this.omcOptionsPlant = [...new Set(this.omcResult.objPlantMaximoNameList)];
    this.omcOptionsPlant = this.omcOptionsPlant.map((item: any) => {
      return {
        label: item,
        value: item
      };
    });
    this.omcOptionsUser = this.omcResult.caiList;
    this.omcOptionsUser = this.omcOptionsUser.map((item: any) => {
      return {
        label: item,
        value: item,
        email: item,
        displayName: item
      };
    });
    this.omcWholeData = this.omcResult.omcRecordList;
    this.selectedOMCUser = this.omcOptionsUser[0].value;
    this.omcWholeData.map((item: any) => {
      if (item.cai == this.selectedOMCUser) {
        this.selectedOMCName = item.displayName;
      }
    });
    this.selectedOMCPlant = this.omcOptionsPlant[0].value;
    this.filterOmcData();
  }
  filterOmcData() {
    this.filterUserIdomcData = this.omcWholeData.filter((item: any) => item.cai === this.selectedOMCUser);
    this.filterPlantomcData = this.omcWholeData.filter((item: any) => ('('+item.plantMaximo + ') ' + item.plantName) === this.selectedOMCPlant);
    this.isLoading = false
  }
  filterChangePlant(event: any) {
    this.filterPlantomcData = this.omcWholeData.filter((item: any) => ('('+item.plantMaximo + ') ' + item.plantName) === this.selectedOMCPlant);
  }
  filterChangeUser(event: any) {
    this.filterUserIdomcData = this.omcWholeData.filter((item: any) => item.cai === this.selectedOMCUser);
    this.omcWholeData.map((item: any) => {
      if (item.cai == this.selectedOMCUser) {
        this.selectedOMCName = item.displayName;
      }
    });
  }

  tabClick() {
    this.showSuccess = false; 
       this.ShowAdded = false;

  }
  showSuccess = false;
  DeleteOmc(record: any) {
    this.showSuccess = false;
    if (confirm(`Are you sure you want to delete a record?`)) {
      this.adminService.deleteOmcData(record.recordID).subscribe((response: any) => {
        this.omcWholeData = this.omcWholeData.filter((item: any) => item.recordID != record.recordID);
        this.filterUserIdomcData = this.filterUserIdomcData.filter((item: any) => item.recordID != record.recordID);
        this.filterPlantomcData = this.filterPlantomcData.filter((item: any) => item.recordID != record.recordID);
        this.messageService.showSuccess('OMC record deleted successfully');
        this.showSuccess = true;
      });
    }
  }

  verifyUserId() {
    this.requiredFlag = false;
    this.validUserEntered = false;
    this.showSuccess = false;
    this.ShowAdded = false;
    if (this.userIdEntered.length > 0) {
      this.maximoList = [];
      this.userService.getMaximoByUser(this.userIdEntered, 'OMC').subscribe({
        next: (response: any) => {
          this.useremail = response.email;
          this.userName = response.displayName;
          this.isValid = response.isValid;
          this.maximoList = response.availablePlants;
        },
        error: (error) => {
          this.validUserEntered = true;
          this.messageService.showError('Please enter a valid User ID');
          this.useremail = '';
          this.userName = '';
          this.selectMaximos = [];
          this.maximoList = [];
          this.isValid = false;
        }
      });
    }
    else {
      this.messageService.showError('Please enter a valid User ID');
      this.requiredFlag = true;
    }
  }
  addNewOMC() {
    this.selectValidMaximo = false;
    this.ShowAdded = false;
    if (this.selectMaximos.length == 0) {
      this.messageService.showError('Please select at least one plant');
      this.selectValidMaximo = true;
      return;
    }
    let payload = {
      "cai": this.userIdEntered,
      "email": this.useremail,
      "displayName": this.userName,
      "plantsListToBeAdded": this.selectMaximos,
      "facilityId": this.facilityName,
      "type": "OMC"
    }
    this.userService.addMaximoForUser(payload).subscribe({
      next: (response: any) => {
        this.messageService.showSuccess('OMC record added successfully');
        this.userIdEntered = '';
        this.useremail = '';
        this.userName = '';
        this.selectMaximos = [];
        this.ShowAdded = true;
        this.maximoList = [];
        this.isValid = false;
        this.getOmcData(); // Refresh the OMC data after adding a new record
      },
      error: (error) => {
        console.error(error);
        this.messageService.showError('Error adding OMC record');
      }
    });
  }
}
